var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"j-quick-tab-wrap"},[_c('div',{staticClass:"j-quick-tab-wrap-scroll"},_vm._l((_vm.$store.state.JMenu.menuQuick),function(menu,index){return _c('j-quick-item',{key:index,attrs:{"id":`j-quick-tab-${menu.menuId}`,"index":index,"meta":menu}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }